import { service } from '@ember/service';
import Component from '@glimmer/component';

import { trackedFunction } from 'reactiveweb/function';

import ContentItems from 'umg-ember-backend/components/page-builder/content-items';

export default class PageBuilderContentItemsItemForMlpSlider extends Component {
  // Services
  @service pageBuilderFrontendApi;
  @service permission;

  // Getter and setter
  get sliderConfig() {
    return this.themeConfig?.cms?.['mlp-slider'];
  }

  get themeConfig() {
    return this.loadThemeConfig.value;
  }

  // Functions
  loadThemeConfig = trackedFunction(this, async () => {
    return await this.pageBuilderFrontendApi.loadThemeConfig(
      this.pageBuilderFrontendApi.host,
      this.args.mlp,
    );
  });

  // Template
  <template>
    <ContentItems
      @contentItems={{@contentItem.children}}
      @contentItemTypeOptions={{this.sliderConfig.contentItems}}
      @isDisabled={{@isDisabled}}
      @mlp={{@mlp}}
      @onSelectContentItem={{@onSelectContentItem}}
      @onSaveMlp={{@onSaveMlp}}
      @parent={{@contentItem}}
      @selectedContentItem={{@selectedContentItem}}
    />
  </template>
}
